import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as redirectLinkActions from './../../../../actions/redirectLinkAction';
import RedirectLink from './RedirectLink';

const mapStateToProps = state => {
    return {
        redirectLinkState: state.redirectLinkReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getRedirectLinks: (filters) => dispatch(redirectLinkActions.getRedirectLinks(filters)),
        deleteRedirectLinkDetail: (redirectLink, filters) => dispatch(redirectLinkActions.deleteRedirectLinkDetail(redirectLink, filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(RedirectLink));
